// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * Note : For multi-location practices, the location_id is the CHILD location id.
 */
export var ValueType;
(function (ValueType) {
    ValueType["VT_UNKNOWN"] = "VT_UNKNOWN";
    ValueType["VT_PROVIDER"] = "VT_PROVIDER";
    ValueType["VT_APPOINTMENT_TYPE"] = "VT_APPOINTMENT_TYPE";
    ValueType["VT_OPERATORY"] = "VT_OPERATORY";
})(ValueType || (ValueType = {}));
export var ValueType_index;
(function (ValueType_index) {
    ValueType_index[ValueType_index["VT_UNKNOWN"] = 0] = "VT_UNKNOWN";
    ValueType_index[ValueType_index["VT_PROVIDER"] = 1] = "VT_PROVIDER";
    ValueType_index[ValueType_index["VT_APPOINTMENT_TYPE"] = 2] = "VT_APPOINTMENT_TYPE";
    ValueType_index[ValueType_index["VT_OPERATORY"] = 3] = "VT_OPERATORY";
})(ValueType_index || (ValueType_index = {}));
export var MappingType;
(function (MappingType) {
    MappingType["UNKNOWN_MAPPING_TYPE"] = "UNKNOWN_MAPPING_TYPE";
    MappingType["PROVIDER_APPOINTMENT_TYPE"] = "PROVIDER_APPOINTMENT_TYPE";
    MappingType["OPERATORY_PROVIDER"] = "OPERATORY_PROVIDER";
    MappingType["APPOINTMENT_TYPE_OPERATORY"] = "APPOINTMENT_TYPE_OPERATORY";
})(MappingType || (MappingType = {}));
export var MappingType_index;
(function (MappingType_index) {
    MappingType_index[MappingType_index["UNKNOWN_MAPPING_TYPE"] = 0] = "UNKNOWN_MAPPING_TYPE";
    MappingType_index[MappingType_index["PROVIDER_APPOINTMENT_TYPE"] = 1] = "PROVIDER_APPOINTMENT_TYPE";
    MappingType_index[MappingType_index["OPERATORY_PROVIDER"] = 2] = "OPERATORY_PROVIDER";
    MappingType_index[MappingType_index["APPOINTMENT_TYPE_OPERATORY"] = 3] = "APPOINTMENT_TYPE_OPERATORY";
})(MappingType_index || (MappingType_index = {}));
